import { createSlice } from '@reduxjs/toolkit'

const initialState = { }

const messageThreadSlice = createSlice({
  name: 'messageThreads',
  initialState,
  reducers: {
    updateThreads(state, { payload }) {
      Object.assign(state, payload)
    },

    replaceOwnerThreads(state, { payload: { threads, owner_id } }) {
      // Remove threads associated with the owner
      Object.entries(state).forEach(([thread_id, thread]) => {
        if (thread.owner_id == owner_id) delete state[thread_id]
      })

      // Add all these threads in
      Object.assign(state, threads)
    },

    setLastRead(state, { thread_id, last_seen_id }) {
      state[thread_id].last_seen_id = last_seen_id
    },
  },
})

export const { setLastRead, updateThreads, replaceOwnerThreads } = messageThreadSlice.actions
export default messageThreadSlice.reducer
